<template>
  <div v-if="isToggle" class="modal z-99999">
    <div class="modal-content">
      <div class="relative grid md:w-454">
        <div class="flex w-full justify-end">
          <button class="close-btn z-50 focus:outline-none px-20 py-10"
                  @click="toggle">
            <i class="far fa-times"></i>
          </button>
        </div>
        <div class="w-full h-full px-20 relative pb-30">
          <div class="font-extrabold text-20 pb-20">
            {{ header }}
          </div>
          <div class="mb-14">
            <a :href="googleUrl" class="w-full border border-black flex items-center justify-center py-18 rounded-lg">
              <img class="w-18 object-cover mr-10"
                   :src="googleIcon"
                   alt="google logo">
              Continue with Google
            </a>
            <a :href="facebookUrl" class="w-full border border-black flex items-center justify-center py-16 rounded-lg mt-10 bg-facebook-blue text-white">
              <img class="w-24 object-cover mr-10"
                   :src="facebookIcon"
                   alt="google logo">
              Continue with Facebook
            </a>
            <slot name="buttons"></slot>
          </div>
          <div class="text-12 text-dark-gray">
            By clicking Continue with Google or Facebook, you agree to drybrush' Terms of Use and Privacy Policy
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignInModal",

  props: {
    googleIcon: { required: true },
    facebookIcon: { required: true },
  },

  data () {
    return {
      isToggle: false,
      header: null,
      parameters: {},
    }
  },

  methods: {
    toggle (parameters = {}, header = 'Sign in to drybrush Gallery.') {
      if (this.isToggle) {
        this.parameters = {}
        document.body.classList.remove('overflow-hidden')
      } else {
        this.parameters = parameters
        document.body.classList.add('overflow-hidden')
      }
      this.header = header
      this.isToggle = ! this.isToggle
    }
  },

  computed: {
    facebookUrl () {
      if (Object.keys(this.parameters).length > 0) {
        return '/oauth/facebook?' + new URLSearchParams(this.parameters).toString()
      }

      return '/oauth/facebook/';
    },

    googleUrl () {
      if (Object.keys(this.parameters).length > 0) {
        return '/oauth/google?' + new URLSearchParams(this.parameters).toString()
      }

      return '/oauth/google';
    }
  }
}
</script>
